import { defineStore } from "pinia";
import { ref } from "vue";

export const useDisabledDirectiveStore = defineStore(
  "disabledDirectiveStore",
  () => {
    const disabled = ref(false);
    const classList = ref([
      "absolute",
      "w-full",
      "h-full",
      "bg-gray-200",
      "inset-0",
      "bg-opacity-5",
      "backdrop-blur-[2px]",
      "flex",
      "justify-center",
      "items-center",
      "cursor-not-allowed",
      "text-untitled-gray-500"
    ]);
    const contentTextClassList = ref(["font-semibold", "text-lg"]);
    const contentText = ref("Hide");

    return {
      disabled,
      classList,
      contentTextClassList,
      contentText,
    };
  }
);
